import { createContext } from 'react'
import { UAParser } from 'ua-parser-js'

export const Platform = createContext(null)
let parser = new UAParser('user-agent')

const PlatformContextProvider = ({ children }) => {
  const getPlatform = () => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    parser.setUA(userAgent)
    const platformName = parser.getOS().name
    if (platformName === 'windows') {
      return 'Windows'
    }
    return 'Mac'
  }
  const platform = getPlatform()
  return <Platform.Provider value={platform}>{children}</Platform.Provider>
}
export default PlatformContextProvider
